// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './common/css/u-css.css'
import requestApi from './api/requestApi'
import { apiUrl } from './api/requestUrl'
import { cntextPath } from './api/requestUrl'
import $ from 'jquery'

import router from './router'  //路由
import moment from 'moment'   //将UTC 通用标准时转为正常时间yyyy-MM-dd
import 'babel-polyfill'

import JsonExcel from 'vue-json-excel'
import axios from 'axios'

Vue.component('downloadExcel', JsonExcel)

Vue.config.productionTip = false
Vue.prototype.$moment = moment

Vue.use(requestApi)   //封装的axios请求接口
Vue.use(ElementUI)

/**
 * 引入百度统计js
 */
import baidu from '@/common/js/baidu'
Vue.use(baidu)

router.afterEach((to, from, next) => {
  // var path = location.href.replace(location.origin , "")
  // console.log("router.before:"+path)
  var path = router.history.current.fullPath
  if (path.indexOf("?") != -1) {
    path = path.substring(0, path.indexOf("?"))
  }
  new Vue().requestApi({
    url: "/api/rec/pageRecord/addPageRecord",
    method: "post",
    data: { url: path },
    then(data) {

    }
  })

});

//全局过滤器
import './common/js/filters.js';

// 添加点击空白处的指令
Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his childrens
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event)
      }
    }
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  }
})
//图表的菜单，单击空白处消失方法(其它组件也可以使用)
Vue.directive('click-echartsMenu',{
    // 初始化指令
    bind(el, binding, vnode) {
        function documentHandler(e) {
            // 这里判断点击的元素是否是本身，是本身，则返回
            if (el.contains(e.target)) {
                return false;
            }
            // 判断指令中是否绑定了函数
            if (binding.expression) {
                // 如果绑定了函数 则调用那个函数，此处binding.value就是指令绑定的方法
                binding.value(e);
            }
        }
        // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
        el.__vueClickOutside__ = documentHandler;
        document.addEventListener('click', documentHandler);
    },
    update() {},
    unbind(el, binding) {
        // 解除事件监听
        document.removeEventListener('click', el.__vueClickOutside__);
        delete el.__vueClickOutside__;
    },
})
Vue.prototype.axios = axios;
/* eslint-disable no-new */
var vue = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  data: {
    apiUrl: apiUrl,
    cntextPath: cntextPath,
    eventHub: new Vue(),
    industryTypeValue: "",
    //标讯搜索部分
    searchTenderQueryType: null,//搜索类型
    searchTenderType: null,//公告类型
    searchTenderGuildIdArray: null,//行业类型
    searchTenderParamSourceArray: null,//发标方
    searchTenderJobTagArray: null,//职能标签
    searchTenderBusinessTypeArray: null,//业务类型
    searchTenderTimeData: null,//时间
    searchTenderTimeStart: null,
    searchTenderTimeEnd: null,
    searchTenderParamProvincesArray: null,//地区
    searchTenderSearchKey: null,//关键字

    searchTenderQueryTypeSecond: null,//搜索类型
    searchTenderTypeSecond: null,//公告类型
    searchTenderGuildIdArraySecond: null,//行业类型
    searchTenderParamSourceArraySecond: null,//发标方
    searchTenderJobTagArraySecond: null,//职能标签
    searchTenderBusinessTypeArraySecond: null,//业务类型
    searchTenderTimeDataSecond: null,//时间
    searchTenderTimeStartSecond: null,
    searchTenderTimeEndSecond: null,
    searchTenderParamProvincesArraySecond: null,//地区
    searchTenderSearchKeySecond: null,//关键字

    //订阅条件部分
    subSearchKey: null,//关键字
    subContentSubscribe: null, //全文订阅
    subAnnouncementData: null,//公告类型
    subFbfData: null,//发标方
    subAreaData: null,//地区
    subPushTime: null,//推送时间
    subPushType: null,//推送类型
    subPushPeroid: null,//推送频率
    subEnabled: null,//是否启动
    subEmail: null,

    // 数据导出，条件缓存
    exportZtbTypes: null,//搜索类型
    exportTenderType:null, //公告类型
    exportGuidId: null,//行业类型
    exportPurchaseSources: null,//发标方，通信/电力
    exportJobTagArray: null,//职能标签，政府
    exportBusinessTypes: null,//业务类型
    exportTimeValue: null,//时间
    exportStartTime: null,
    exportEndTime: null,
    exportAreaData: null,//地区
    exportKeyword: null,//关键字
    exportZhaoBiaoCompany: null,//招标
    exportZhongBiaoCompany: null,//中标
    exportSingleCompany :false,
  }
})



// WEBPACK FOOTER //
// ./src/main.js